// extracted by mini-css-extract-plugin
export var base = "_2g-0";
export var updateBanner = "_2g-1";